import { MARQUEE_ITEMS } from "../lib/data";

export const Marquee = ({ items = MARQUEE_ITEMS, testId = "marquee" }) => {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-surface/60 py-5" data-testid={testId}>
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className={`px-6 font-display text-lg sm:text-xl ${i % 2 ? "italic text-champagne/80" : "text-neutral-400"}`}>
                  {item}
                </span>
                <span className="text-gold/70 text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
